module.exports = __webpack_public_path__ + "img/profile.6f98dc7f.svg";